import script from "./CatalogSectionItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./CatalogSectionItem.vue?vue&type=script&setup=true&lang=ts"

import "./CatalogSectionItem.vue?vue&type=style&index=0&id=42f0b348&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42f0b348"]])

export default __exports__